<template>
  <div id="app" :class="{ 'touch-version': isTouchVersion }">
    <div class="layout-switch">
      <button @click="toggleLayout" class="switch-btn">
        {{ isTouchVersion ? '切换到正常版' : '切换到触屏版' }}
      </button>
    </div>
    <router-view :key="$i18n.locale" :is-touch-version="isTouchVersion" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isTouchVersion: false
    }
  },
  methods: {
    toggleLayout() {
      this.isTouchVersion = !this.isTouchVersion;
    }
  },
  created() {
    // 设置语言
    const browserLang = navigator.language || navigator.userLanguage;
    const defaultLang = browserLang.toLowerCase().startsWith('zh') ? 'zh' : 'en';
    const savedLang = localStorage.getItem('lang');
    
    if (!savedLang) {
      this.$i18n.locale = defaultLang;
      localStorage.setItem('lang', defaultLang);
    } else {
      this.$i18n.locale = savedLang;
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  letter-spacing: 1px !important;
}
html,
body {
  height: 100%;
  width: 100%;
}
.el-dialog__title {
  font-size: 20px ;
  font-weight: bold ;
}

.layout-switch {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  transition: opacity 0.3s ease;
  display: none; /* 隐藏切换按钮 */

  .switch-btn {
    background: #85b62c;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &:hover {
      background: #6d9623;
      transform: scale(1.05);
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>
